import { createApp } from 'vue';
import SelectionItemArchiveModal from '@pages/selection-item/components/SelectionItemArchiveModal.vue';
import { pinia } from '@tools/pinia';

export const initSelectionArchiveModalLoader = (): void => {
  const elementId = '#selection-archive-modal-app';

  if (!document.querySelector(elementId)) {
    return;
  }

  createApp(SelectionItemArchiveModal)
    .use(pinia)
    .mount(elementId);
};
